export default "__VITE_ASSET__Q64XOv8s__"